import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(132,204,22,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-132">
          {/* Subtle background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[50px] pointer-events-none" data-id="element-133"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-134">
            <span className="text-5xl drop-shadow-[0_0_15px_rgba(132,204,22,0.5)]" data-id="element-135">
              🛡️
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-136">
            RECUPERA TU TIEMPO O TE DEVOLVEMOS TU DINERO
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-137">
            Estamos tan seguros de que este sistema de EDULABS te ahorrará horas
            de trabajo, que te damos{' '}
            <span className="text-primary font-bold" data-id="element-138">7 días para probarlo</span>
            . Si no sientes que tu vida de docente es más fácil, dinos y te
            devolvemos cada centavo.{' '}
            <span className="text-text-main font-bold" data-id="element-139">Sin preguntas.</span>
          </p>
        </div>
      </div>
    </section>;
}